/* eslint-disable react-native/no-unused-styles */
/* eslint-disable react-native/no-color-literals */
/* eslint-disable react-native/no-inline-styles */
/* eslint-disable react/prop-types */
/*
Author: Gilang Romadhanu Tartila
*/

import React, { useState, useEffect, useMemo, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Dimensions, View } from 'react-native';
import SociollaText from '@components/sociolla/SociollaText';
import Colors from '@global/colors';
import Button from '@components/form/Button';
import ItemDetail from '@components/global/ItemDetail';
import StatusBadge from '@components/global/StatusBadge';
import SelectBox from '@components/form/SelectBox';
import * as Layout from '@components/screen/Layout';
import { isWeb, isMobileWeb } from '@global/screens';
import { setTempData } from '@/store/global';
import {
  parseDate,
  currency,
  hasNoAccess,
  isValidObjectId,
  exportCsvApi,
} from '@global/helpers';
import Toast from 'react-native-toast-message';
import DefaultButtonAction from '@/screens/task-notification/components/DefaultButtonAction';
import Input from '@components/form/Input';
import BudgetPocketSearch from '@components/form/search/BudgetPocketSearch';
import SociollaTable from '@components/sociolla/SociollaTable';
import TitleSubSection from '@components/global/TitleSubSection';
import ModalHalf from '@components/modal/ModalHalf';
import FullLoader from '@/components/global/FullLoader';

import useApi from '@/hooks/useApi';
import { MsOrder } from '@api/ms-order';
import { showPopup } from '@/store/modal';
import { Formik } from 'formik';
import ScrollContainer from '@components/global/ScrollContainer';

const { height: windowHeight } = Dimensions.get('window');
const ScrollComponent = isMobileWeb ? ScrollContainer : View;
const HEADER_DEKSTOP = [
  {
    label: 'Budget Value',
    data: 'budget_value',
    type: 'price',
    width: '9%',
    styleItem: { alignItems: 'stretch' },
  },
  {
    label: 'Budget Remaining',
    data: 'budget_remaining',
    type: 'price',
    width: '9%',
    styleItem: { alignItems: 'stretch' },
  },
  {
    label: 'Budget Used',
    data: 'budget_used',
    type: 'price',
    width: '9%',
    styleItem: { alignItems: 'stretch' },
  },
  {
    label: 'Transfer Out',
    data: 'transfer_out',
    type: 'price',
    width: '9%',
    styleItem: { alignItems: 'stretch' },
  },
  {
    label: 'Transfer In',
    data: 'transfer_in',
    type: 'price',
    width: '9%',
    styleItem: { alignItems: 'stretch' },
  },
  {
    label: 'Budget Final',
    data: 'budget_final',
    type: 'price',
    width: '10%',
    styleItem: { alignItems: 'stretch' },
  },
  {
    label: 'Budget Remaining New',
    data: 'budget_remaining_new',
    type: 'price',
    width: '13%',
    styleItem: { alignItems: 'stretch' },
  },
  {
    label: 'Budget Name',
    data: 'budget_name',
    width: '12%',
    numberOfLines: 2,
    styleItem: { alignItems: 'flex-start', paddingHorizontal: 12 },
  },
  {
    label: 'Last Updated, By',
    data: 'last_updated_by',
    width: '20%',
    numberOfLines: 2,
    styleItem: { alignItems: 'flex-start', paddingHorizontal: 12 },
  },
];

const BudgetPocketDetailScreen = (props) => {
  const tableRef = useRef();
  const dispatch = useDispatch();
  const userData = useSelector((state) => state.auth.user);
  const [detailData, setDetailData] = useState({});
  const [showTransfer, setShowTransfer] = useState(false);
  const [exporting, setExporting] = useState(false);
  const [transferHistories, setTransferHistories] = useState([]);
  const [transferHistoriesCount, setTransferHistoriesCount] = useState(0);
  const [loadingMoreTable, setLoadingMoreTable] = useState(false);
  const [loadingTable, setLoadingTable] = useState(false);
  const [showTransferLoader, setShowTransferLoader] = useState(false);
  const [isAfterAction, setIsAfterAction] = useState(false);
  const [paramsTable, setParamsTable] = useState({
    filter: {},
    limit: 10,
    skip: 0,
  });

  const from = props?.route?.params?.name;

  const hasEditAccess = useMemo(() => {
    return (
      hasNoAccess([
        'vice_president_finance',
        'budget_controller',
        'finance_head',
        'tax_support',
        'billing_supervisor',
        'general_manager_marketing',
        'marketing_support',
      ]) && detailData?.current_status != 'need_approval'
    );
  }, [detailData]);

  const budgetPocketSearchFilter = useMemo(() => {
    return {
      current_status: 'approved',
      is_active: false,
      _id: { $ne: detailData?._id },
    };
  }, [detailData]);

  const hasTransferAccess = useMemo(() => {
    return (
      !hasNoAccess(['superadmin', 'general_manager_marketing', 'general']) &&
      detailData?.current_status == 'approved'
    );
  }, [detailData]);

  const showApproval = useMemo(() => {
    return (
      detailData.current_status == 'need_approval' &&
      detailData?.current_approval == userData?.role?.code
    );
  }, [detailData, userData]);

  const getBudgetPocketDetail = useApi(MsOrder.getBudgetPocketDetail);
  const transferBudget = useApi(MsOrder.transferBudget);
  const getTransferBudgetHistories = useApi(MsOrder.getTransferBudgetHistories);
  const getTransferBudgetHistoriesCount = useApi(
    MsOrder.getTransferBudgetHistoriesCount,
  );

  const getDetail = async (id) => {
    const response = await getBudgetPocketDetail.request(id);
    if (response?.data?.data && Object.keys(response.data.data).length) {
      const result = response.data.data;
      result.periode = `${
        result.start_date ? parseDate(result.start_date) : '-'
      } - ${result.end_date ? parseDate(result.end_date) : '-'}`;
      result.last_updated = `${
        result.updated_at ? parseDate(result.updated_at) : '-'
      }`;
      dispatch(setTempData(result?.current_status));
      setDetailData(result);
    } else {
      setDetailData({});
    }
  };

  const onChangeActive = async (isActive) => {
    try {
      await MsOrder.updateStatusActiveBudgetPocket(detailData?._id, {
        is_active: isActive,
      });
    } catch (error) {}
  };

  const onApprove = async () => {
    dispatch(showPopup({ name: 'isLoading', value: true }));
    try {
      const response = await MsOrder.changeStatusBudgetPocket(
        detailData._id,
        'approved',
      );
      if (response?.data?.data && Object.keys(response.data.data).length) {
        Toast.show({ text1: 'Successfully processed data', type: 'success' });
        getDetail(props.route.params.id);
        setIsAfterAction(true);
        dispatch(showPopup({ name: 'isLoading', value: false }));
      } else {
        dispatch(showPopup({ name: 'isLoading', value: false }));
        Toast.show({ text1: 'A system error occurred', type: 'error' });
      }
    } catch (error) {
      dispatch(showPopup({ name: 'isLoading', value: false }));
      Toast.show({ text1: 'A system error occurred', type: 'error' });
    }
  };

  const onReject = async () => {
    dispatch(showPopup({ name: 'isLoading', value: true }));
    try {
      const response = await MsOrder.changeStatusBudgetPocket(
        detailData._id,
        'rejected',
      );
      if (response?.data?.data && Object.keys(response.data.data).length) {
        getDetail(props.route.params.id);
        setIsAfterAction(true);
        dispatch(showPopup({ name: 'isLoading', value: false }));
        Toast.show({ text1: 'Successfully processed data', type: 'success' });
      } else {
        dispatch(showPopup({ name: 'isLoading', value: false }));
        Toast.show({ text1: 'A system error occurred', type: 'error' });
      }
    } catch (error) {
      dispatch(showPopup({ name: 'isLoading', value: false }));
      Toast.show({ text1: 'A system error occurred', type: 'error' });
    }
  };

  const getTransferHistories = async (id, param = null) => {
    setLoadingTable(true);
    const params = param ? param : { ...paramsTable };
    getTransferBudgetHistories.request(id, { params }).then((response) => {
      if (response?.data?.data) {
        let res = response.data.data;
        res = (res || []).map((r) => {
          const lastUpdatedDate = r.updated_by?.date
            ? parseDate(r.updated_by.date)
            : '';
          const lastUpdatedName = r.updated_by?.name || '';
          r.last_updated_by = `${lastUpdatedDate}, ${lastUpdatedName}`;
          r.budget_name = r.transfer_out_budget?.name
            ? r.transfer_out_budget.name
            : r.transfer_in_budget?.name
            ? r.transfer_in_budget.name
            : '';
          return r;
        });
        setTransferHistories([...res]);
        setLoadingMoreTable(false);
        setLoadingTable(false);
      }
    });
  };

  const getTransferHistoriesCount = async (id) => {
    getTransferBudgetHistoriesCount.request(id).then((response) => {
      setTransferHistoriesCount(response?.data?.data || 0);
    });
  };

  const onSearchTable = async (param, type) => {
    const params = { ...paramsTable };
    if (type === 'pagination') {
      setLoadingMoreTable(true);
      params.limit = param.limit;
      params.skip = param.skip;
    }
    await setParamsTable({ ...params });
    getTransferHistories(detailData?._id, params);
  };

  useEffect(() => {
    let mounted = true;
    if (mounted) {
      setDetailData({});
      const id = props?.route?.params?.id;
      if (isValidObjectId(id)) {
        getDetail(id);
      }
    }
    return () => {
      mounted = false;
    };
  }, [props]);

  useEffect(() => {
    let mounted = true;
    if (mounted) {
      const id = props?.route?.params?.id;
      if (isValidObjectId(id)) {
        getTransferHistoriesCount(id);
        getTransferHistories(id);
      }
    }
    return () => {
      mounted = false;
    };
  }, [props]);

  const goToForm = () => {
    if (detailData._id) {
      props.navigation.navigate('BudgetPocketFormScreen', {
        titleScreen: detailData.name,
        name: detailData.name,
        id: detailData._id,
      });
    }
  };

  const onExportSoReport = async () => {
    setExporting(true);
    try {
      await exportCsvApi(
        'budget-pocket-so-report',
        { budget_id: detailData._id },
        {
          isDownload: false,
          message: 'Export in progress, the result will be sent to your email.',
        },
      );
    } finally {
      setExporting(false);
    }
  };

  return (
    <Layout.Container>
      {isWeb ? (
        <Layout.Back
          title={from === 'Budget Pocket Approval' ? 'Task' : 'Budget Pocket'}
          onCallback={() => {
            if (from === 'Budget Pocket Approval') {
              props.navigation.navigate('TaskNotificationNavigator', {
                screen: 'TaskNotificationScreen',
                params: {
                  task: true,
                },
              });
            } else if (isAfterAction) {
              props.navigation.push('BudgetPocketScreen', {
                isAfterAction: true,
              });
            } else {
              props.navigation.navigate('BudgetPocketScreen');
            }
          }}
        />
      ) : (
        false
      )}
      <Layout.Wrapper rounded style={{ maxWidth: 'none', width: '100%' }}>
        {getBudgetPocketDetail && getBudgetPocketDetail.loading ? (
          <Layout.Loader />
        ) : (
          <>
            <Layout.Title
              title={detailData.name}
              style={{
                paddingTop: isWeb ? 25 : 15,
                paddingHorizontal: isWeb ? 25 : 15,
              }}>
              {isWeb ? (
                <View
                  style={{
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                  }}>
                  {showApproval ? (
                    <DefaultButtonAction
                      style={{ width: 'auto' }}
                      onReject={() => onReject()}
                      onApprove={() => onApprove()}
                    />
                  ) : (
                    false
                  )}
                  {hasEditAccess ? (
                    <View
                      style={
                        showApproval
                          ? { marginLeft: 8 }
                          : hasTransferAccess
                          ? { marginRight: 8 }
                          : {}
                      }>
                      <Button
                        type="primary"
                        rounded
                        buttonStyle={{ width: 100 }}
                        title={
                          <SociollaText
                            type="bold"
                            style={{ fontSize: 14, color: Colors.white }}>
                            Edit
                          </SociollaText>
                        }
                        onPress={() => goToForm()}
                      />
                    </View>
                  ) : (
                    false
                  )}
                  {hasTransferAccess ? (
                    <View>
                      <Button
                        type="primary"
                        rounded
                        buttonStyle={{ width: 100 }}
                        title={
                          <SociollaText
                            type="bold"
                            style={{ fontSize: 14, color: Colors.white }}>
                            Transfer
                          </SociollaText>
                        }
                        onPress={() => setShowTransfer(true)}
                      />
                    </View>
                  ) : (
                    false
                  )}
                  {detailData?._id ? (
                    <View style={{ marginLeft: 8 }}>
                      <Button
                        type="secondary"
                        rounded
                        disabled={exporting}
                        buttonStyle={{ width: 120 }}
                        title={
                          <SociollaText
                            type="bold"
                            style={{ fontSize: 14, color: Colors.white }}>
                            {exporting ? 'Loading...' : 'Export SO'}
                          </SociollaText>
                        }
                        onPress={() => onExportSoReport()}
                      />
                    </View>
                  ) : (
                    false
                  )}
                </View>
              ) : (
                false
              )}
            </Layout.Title>
            <ScrollComponent
              style={{
                width: isWeb ? 'fit-content' : '100%',
                maxWidth: '100%',
                paddingVertical: 15,
                paddingHorizontal: isWeb ? 25 : 15,
                ...(isWeb ? {} : { height: windowHeight * 0.8 }),
              }}>
              <ItemDetail
                name="Budget Name"
                value={detailData?.name ? detailData.name : '-'}
              />
              <ItemDetail
                name="Budget Description"
                value={detailData?.description ? detailData.description : '-'}
              />
              <ItemDetail
                name="Budget Value"
                value={
                  detailData?.value ? currency(detailData.value, true) : '-'
                }
              />
              <ItemDetail
                name="Budget Remaining"
                value={
                  detailData?.budget_remaining
                    ? currency(detailData.budget_remaining, true)
                    : '-'
                }
              />
              {showTransfer ? (
                <ModalHalf
                  title="Transfer Amount"
                  visible={showTransfer}
                  maxWidth={isWeb ? 350 : '100%'}
                  spaceFromTop={isWeb ? '20%' : false}
                  headerBordered={isWeb ? true : false}
                  onClose={() => setShowTransfer(false)}>
                  {showTransferLoader ? <FullLoader show={true} /> : false}
                  <Formik
                    initialValues={{ transfer_amount: '', transfer_budget: '' }}
                    onSubmit={async (values, { resetForm }) => {
                      setShowTransferLoader(true);
                      try {
                        const payload = {
                          amount: Number(values.transfer_amount),
                          budget: {
                            id: values.transfer_budget?._id,
                            name: values.transfer_budget?.name,
                          },
                        };
                        const response = await transferBudget.request(
                          detailData?._id,
                          payload,
                        );
                        if (response?.data?.data?.length) {
                          setTransferHistoriesCount(transferHistoriesCount + 1);
                          getTransferHistories(detailData?._id);
                          Toast.show({
                            text1: 'Budget amount transferred out successfully',
                            type: 'success',
                          });
                        } else {
                          Toast.show({
                            text1: 'Failed to transfer budget amount',
                            type: 'error',
                          });
                        }
                        resetForm();
                        setShowTransferLoader(false);
                        setShowTransfer(false);
                      } catch (error) {
                        Toast.show({
                          text1:
                            (error &&
                              error.response &&
                              error.response.data &&
                              error.response.data.message) ||
                            'A system error occurred',
                          type: 'error',
                        });
                        resetForm();
                        setShowTransferLoader(false);
                        setShowTransfer(false);
                      }
                    }}>
                    {({
                      handleChange,
                      setFieldValue,
                      handleSubmit,
                      resetForm,
                      errors,
                      touched,
                      values,
                    }) => (
                      <View>
                        <View
                          style={{
                            width: '100%',
                            paddingHorizontal: 15,
                            paddingTop: 10,
                          }}>
                          <ItemDetail
                            name="Budget Transfer Out"
                            nameStyle={{ fontSize: 14 }}
                            value={
                              <Input
                                value={values.transfer_amount}
                                isRequired={true}
                                isNumeric={true}
                                hasError={
                                  errors.value && touched.value
                                    ? errors.value
                                    : null
                                }
                                onChangeText={handleChange('transfer_amount')}
                              />
                            }
                          />
                          <ItemDetail
                            nameStyle={{ fontSize: 14 }}
                            name="Transfer To"
                            value={
                              <BudgetPocketSearch
                                isRequired={true}
                                isShowLabel={false}
                                customFilter={budgetPocketSearchFilter}
                                value={values.transfer_budget}
                                hasError={
                                  errors.budget && touched.budget
                                    ? errors.budget
                                    : null
                                }
                                onChange={(value) =>
                                  setFieldValue('transfer_budget', value)
                                }
                              />
                            }
                          />
                        </View>

                        <View
                          style={{
                            width: '100%',
                            flexDirection: 'row',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                          }}>
                          <View
                            style={{
                              width: isWeb ? 150 : '48%',
                              marginHorizontal: '1%',
                            }}>
                            <Button
                              type="default"
                              rounded={true}
                              buttonStyle={{ width: '100%' }}
                              title={
                                <SociollaText
                                  type="bold"
                                  style={{ fontSize: 14, letterSpacing: 0.5 }}>
                                  Cancel
                                </SociollaText>
                              }
                              onPress={() => {
                                resetForm(values);
                                setShowTransfer(false);
                              }}
                            />
                          </View>
                          <View
                            style={{
                              width: isWeb ? 150 : '48%',
                              marginHorizontal: '1%',
                            }}>
                            <Button
                              rounded={true}
                              buttonStyle={{ width: '100%' }}
                              title={
                                <SociollaText
                                  type="bold"
                                  style={{
                                    fontSize: 14,
                                    letterSpacing: 0.5,
                                    color: Colors.white,
                                  }}>
                                  Submit
                                </SociollaText>
                              }
                              onPress={() => handleSubmit(values)}
                            />
                          </View>
                        </View>
                      </View>
                    )}
                  </Formik>
                </ModalHalf>
              ) : (
                false
              )}
              <ItemDetail
                name="Periode"
                value={detailData?.periode ? detailData.periode : '-'}
              />
              <ItemDetail
                name="Is Active"
                centered
                value={
                  !hasNoAccess([
                    'superadmin',
                    'budget_controller',
                    'marketing_admin',
                    'general_manager_marketing',
                    'vice_president',
                    'general',
                  ]) ? (
                    <SelectBox
                      label="Status"
                      hideLabel
                      options={[
                        { name: 'Active', value: true },
                        { name: 'Inactive', value: false },
                      ]}
                      value={{
                        name: detailData.is_active ? 'Active' : 'Inactive',
                        value: detailData.is_active,
                      }}
                      trackBy="value"
                      labelKey="name"
                      onChange={(val) => {
                        const finalValue = val.value;
                        const payload = {
                          ...detailData,
                          is_active: finalValue,
                        };
                        setDetailData(payload);
                        onChangeActive(finalValue);
                      }}
                    />
                  ) : (
                    <StatusBadge
                      status={detailData.is_active ? 'active' : 'inactive'}
                    />
                  )
                }
              />
              <ItemDetail
                name="Status"
                centered
                value={<StatusBadge status={detailData?.current_status} />}
              />
              <ItemDetail
                name="Last Updated, By"
                value={`${
                  detailData.updated_at ? parseDate(detailData.updated_at) : '-'
                }${
                  detailData?.updated_by?.name
                    ? `, ${detailData.updated_by.name}`
                    : ''
                }`}
              />
            </ScrollComponent>
          </>
        )}
        {!isWeb && detailData?._id && showApproval ? (
          <Layout.ButtonSticky
            show={
              props?.route?.name == 'BudgetPocketDetailScreen' &&
              Boolean(detailData?._id)
            }
            route={props?.route}
            buttons={[
              {
                component: (
                  <DefaultButtonAction
                    onReject={() => onReject()}
                    onApprove={() => onApprove()}
                  />
                ),
              },
            ]}
          />
        ) : (
          false
        )}
        {isWeb && transferHistories?.length ? (
          <View>
            <TitleSubSection title="History Transfer Budget" />
            <SociollaTable
              table={HEADER_DEKSTOP}
              ref={tableRef}
              datas={transferHistories}
              showSearch={false}
              searchBorder={true}
              scrollItem={true}
              showPagination={true}
              stickyHeaderIndices={[0]}
              emptyLabel={'No history found.'}
              count={transferHistoriesCount}
              loading={loadingTable}
              loadingLoadMore={loadingMoreTable}
              onSearchTable={(val, type) => onSearchTable(val, type)}
              localParams={paramsTable}
              hideBottomPagination={true}
              styleRow={{ height: '100%' }}
            />
          </View>
        ) : (
          false
        )}
      </Layout.Wrapper>
    </Layout.Container>
  );
};

export default BudgetPocketDetailScreen;
